<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4">
<div class="img_containerl"><img alt="image" src="images/f0004-01.jpg"/></div>
<p class="copy">Napoleon’s Imperial Guard Uniforms and Equipment. Volume 2</p>
<p class="copy">THE CAVALRY</p>
<p class="copya">First published in Great Britain in 2019 by Frontline Books, an imprint of Pen &amp; Sword Books Ltd, Yorkshire - Philadelphia</p>
<p class="copya">Copyright © Paul L. Dawson</p>
<p class="copy">Colour plates copyright © Keith Rocco</p>
<p class="copy">ISBN: 978-152670-896-0</p>
<p class="copy">eISBN: 978-152670-898-4</p>
<p class="copy">Mobi ISBN: 978-152670-897-7</p>
<p class="copya">The right of Paul L. Dawson to be identified as Author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988. A CIP catalogue record for this book is available from the British Library All rights reserved.</p>
<p class="copya">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Archaeology, Air World Books, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Social History, Transport, True Crime, Claymore Press, Frontline Books, Praetorian Press, Seaforth Publishing and White Owl</p>
<p class="copya">For a complete list of Pen &amp; Sword titles please contact:</p>
<p class="copya">PEN &amp; SWORD BOOKS LTD</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
</a><p class="copy"><a id="page_4">E-mail: <span class="weblink"></span></a><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Or</p>
<p class="copy">PEN AND SWORD BOOKS,</p>
<p class="copy">1950 Lawrence Roadd, Havertown, PA 19083, USA</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.penandswordbooks.com" target="_blank"><span class="underline">www.penandswordbooks.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?65f8b86a